import {
    Box,
    CardActions,
    Stack,
    Typography,
    Button,
    Grid
} from '@mui/material';
import { MicrosoftExcel, Printer } from 'mdi-material-ui';  
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { apiService } from '../../../api/axiosClient';
import Stat from 'src/components/mui/chip/stat'
import { getOrderNumbers } from 'src/utils/shop'
import MenuOrder from 'src/views/menu/MenuOrder'
import Page from '../../../components/Page'
import PageHeader from '../../../components/page-header'
import { useGetOrdersQuery } from '../../../store/orderApi'
import BoxWrapper from '../../../styles/BoxWrapper'
import TableOrder from '../../../views/order/TableOrder'

const OrderList = () => {
    const [reload, setReload] = useState(0);
    const [total, setTotal] = useState(0);
    const [filters, setFilters] = useState({});
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const { data, error } = useGetOrdersQuery('all', {
        refetchOnFocus: true
    });
  
    useEffect(() => {
        data && setTotal(data.data)
    }, [data]);

    const sheetDownload = async () => {
        await apiService.get('/proc/order/excel', {
            params: {
                ...filters
            },
            responseType: 'blob'
        }).then(response => {
            const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "주문리스트.xlsx";
            document.body.appendChild(a);
            a.click();
        }).catch(error => {
            console.error(error)
        });
    }

    return (
        <Page title="통합주문">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                        <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                            <Typography variant='h5' color='#666CFF'>
                                통합주문
                            </Typography>
                            <Stat value={total}/>
                        </Stack>
                    }
                />
                <BoxWrapper>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <MenuOrder setFilters={setFilters} setReload={setReload} />
                    </Box>

                    <TableOrder filters={filters} submit={reload} selected={selected} setSelected={setSelected} 
                        page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />

                    <CardActions className='card-action-dense'>
                        <Stack direction="row" spacing={2}>
                            <Button variant='contained' startIcon={<MicrosoftExcel />} onClick={sheetDownload}>엑셀출력</Button>
                        </Stack>
                        <Stack direction="row" spacing={2} sx={{pl: 4}}>          
                            <Button component={Link} 
                                to={`/form/order?orderids=${getOrderNumbers(selected)}`} 
                                target="_blank" 
                                variant='contained' color='success' startIcon={<Printer />} disabled={selected.length === 0}>거래명세</Button>
                            <Button component={Link} 
                                to={`/form/delivery?orderids=${getOrderNumbers(selected)}`} 
                                target="_blank" 
                                variant='contained' color='success' startIcon={<Printer />} disabled={selected.length === 0}>납품명세</Button>
                            <Button component={Link} 
                                to={`/form/spec?orderids=${getOrderNumbers(selected)}`} 
                                target="_blank" 
                                variant='contained' color='success' startIcon={<Printer />} disabled={selected.length === 0}>견적서</Button>
                        </Stack>
                    </CardActions>
                </BoxWrapper>
            </Grid>
        </Page>
    )
}

export default OrderList